import { createContext } from 'react';

export const AgentContext = createContext({
    isB2B: false
});